import UIFetchService from '../Service/UIFetchService';
import { isEmpty, isNotEmpty } from '../Service/Utils';
import auth from '../Service/AuthFetchService';
import moment from 'moment'
import copy from 'copy-to-clipboard';
import './Trace.css';
import React from 'react';
import {
    InputNumber,
    Button,
    Row,
    Col,
    Select,
    Input,
    Table,
    Modal,
    Tag,
    Popconfirm,
    message,
    Switch,
    Tabs,
    Image,
    Tooltip,
    Spin
} from 'antd';
import {
    DeleteOutlined,
    PlusOutlined,
    CopyOutlined,
    QuestionCircleOutlined
} from '@ant-design/icons';
import { HotTable } from '@handsontable/react';
import Handsontable from 'handsontable';
import TraceChannel from './TraceChannel'
import TraceParamEdit from './TraceParamEdit'

class TraceParamsView extends React.Component {
    constructor() {
        super()
        this.state = {
            teams: [
                '百词斩(bcz)', 
                '薄荷芝士派(bozhi)', 
                '夜曲编程(yequ)', 
                '成人英语(cryy)', 
                '大学数学(dxsx)', 
                '柚子鸭(yzy)', 
                '战略中台(zlzt)',
                '成人业务平台(crywpt)',
                'mintlife'
            ],
            activeKey: 'paramList'
        }
    }

    async componentDidMount() {
        const user = await auth.authenticate();
        this.setState({ user })
        window.CyaLogger?.sendCustomEvent("page_view", null, "datap_liuliagfenxi_pv", { page_name: "追踪参数", user_name: user.account })
    }

    render() {

        return <>
                <Tabs type="card" className="paramTabs">
                    <Tabs.TabPane tab="参数列表" key="paramList">
                        <ParamListView teams={this.state.teams} />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="链接列表" key="linkList" >
                        <LinkListView teams={this.state.teams} />
                    </Tabs.TabPane>
                </Tabs>
            </>
    }
}

class ParamListView extends React.Component {

    constructor() {
        super()
        this.state = {
            keyword: '',
            pageIndex: 0,
            pageSize: 20,
            filters: {
                team: null,
                channelCategory: null,
                channel: null,
                paramKey: null,
                creator: null,
                status: null
            },
            total: 0,
            items: [],

            // showingEditBasicInfoModal: false,
            showingChannelModal: false,
            basicInfoDirty: null,
            showingEditParamModal: false,
            showingImportModal: false,
            isCreateParam: false,
            editingParam: null,
            generatingLinkParam: null,
            paramCreators: [],
            channelLevels: [],
            channels: [],
        }
    }

    async componentDidMount() {
        this._refreshParams({ pageIndex: 1})
        this.fetchParamCreators()
        this.fetchChannelLevels()
        this.fetchChannels()
    }

    async _refreshParams(params) {
        const keys = ['pageIndex', 'pageSize', 'keyword', 'filters'];
        const queries = [];
        for (let key of keys) {
            if (params[key] === undefined) {
                params[key] = this.state[key];
            }

            if (key === 'filters') {
                queries.push(`${key}=${encodeURI(JSON.stringify(params[key]))}`);
            } else if (params[key] !== undefined) {
                queries.push(`${key}=${encodeURI(params[key])}`);
            }
        }
        this.setState({ ...params });
        const rv = await UIFetchService.get(`/api/v1/trace/params?${queries.join('&')}`);
        if (rv) {
            this.setState({ total: rv.total, items: rv.items });
        }
    }
    
    async fetchParamCreators() {
        UIFetchService.get('/api/v1/trace/params/creators')
            .then((paramCreators) => this.setState({ paramCreators }))
    }

    async fetchChannelLevels() {
        const res = await UIFetchService.get('/api/v1/trace/channel/levels')
        const flatChannelLevels = []
        for (let chn of res) {
            flatChannelLevels.push({
                id: chn.id,
                name: chn.name,
                level: 1
            })
            for (let subChn of chn.subChannels) {
                flatChannelLevels.push({
                    id: subChn.id,
                    name: `${chn.name}/${subChn.name}`,
                    level: 2
                })
            }
        }
        this.setState({
            channelLevels: flatChannelLevels
        })
    }

    async fetchChannels() {
        const res = await UIFetchService.get('/api/v1/trace/channels')
        this.setState({
            channels: res
        })
    }

    async deleteParam(id) {
        UIFetchService.delete(`/api/v1/trace/params/${id}`)
            .then((result) => {
                if (result != null) {
                    message.success("删除追踪参数成功")
                    this._refreshParams({})
                }
            })
    }

    async switchParamStatus(record, status) {
        UIFetchService.method('PATCH', `/api/v1/trace/params/${record.id}/switchStatus?status=${status}`)
            .then((result) => {
                if (result != null) {
                    message.success("修改追踪参数状态成功")
                    this.setState(({ items }) => {
                        record.status = status
                        return { items };
                    })
                }
            })            
    }

    async editParam(record) {
        this.setState({
            showingEditParamModal: true,
            isCreateParam: false,
            editingParam: record
        })
    }

    async generateLink(record) {
        this.setState({
            showingEditLinkModal: true,
            generatingLinkParam: record
        })
    }

    render() {
        return <>
            <Row style={{marginTop: 25}}>
                <Col flex="10px"></Col>
                <Col>
                    <Input.Search
                        value={this.state.keyword}
                        onChange={async ({ target: { value } }) => await this._refreshParams({ keyword: value, pageIndex: 1 })}
                        style={{ width: 350 }}
                        placeholder="输入追踪参数标识/追踪参数描述"
                    />
                </Col>
                <Col flex='20px'></Col>
                <Col style={{ alignSelf: 'center' }}>
                    <a href='/real_time/trace_params/tutorial' target='_blank'>追踪参数使用流程说明</a>
                </Col>
                <Col flex="auto"></Col>
                <Col style={{ padding: '0 10px 0 0' }}>
                    < Button
                        size="small"
                        onClick={() => { 
                            if (!auth.allow('datap:real_time:trace_basic_info:manage')) {
                                message.warn("您没有批量导入的权限")
                                return
                            }
                            this.setState({ showingImportModal: true }) 
                        }}
                    >批量导入参数</Button> 
                </Col>
                <Col style={{ padding: '0 10px 0 0' }}>
                    {auth.allow('datap:real_time:trace_basic_info:manage') &&< Button
                        size="small"
                        onClick={() => this.setState({ showingChannelModal: true })}
                    >渠道管理</Button> }
                </Col>
                <Col style={{ padding: '0 10px 0 0' }}>
                    <Button
                        size="small"
                        type="primary"
                        onClick={() => this.setState({ showingEditParamModal: true, isCreateParam: true })}
                    //disabled={isEmpty(this.state.projectName) || isEmpty(this.state.appName)}
                    >新增追踪参数</Button>
                </Col>
            </Row>
            <div style={{ height: 16 }} />
            <Row>
                <Col flex="100%" style={{ padding: '10px' }}>
                    <Table
                        dataSource={this.state.items}
                        bordered
                        size="small"
                        pagination={{
                            total: this.state.total,
                            current: this.state.pageIndex,
                            pageSize: this.state.pageSize,
                        }}
                        rowKey="id"
                        style={{
                            width: '100%',
                        }}
                        scroll={{ y: this.state.tableHeight, x: 1200 }}
                        onChange={(pagination, filters, sorter, { action }) => {
                            this._refreshParams({
                                pageIndex: pagination.current,
                                pageSize: pagination.pageSize,
                                filters
                            });
                        }}
                    >
                        <Table.Column
                            title="ID"
                            dataIndex="id"
                            key="id"
                            width={80}
                            fixed="left"
                            render={id => <Tag>{id}</Tag>}
                        />
                        <Table.Column
                            title="追踪参数标识"
                            dataIndex="paramId"
                            key="paramId"
                            width={200}
                            fixed="left"
                            
                            render={(paramId, record) => 
                            <div style={{ wordWrap: 'break-word', wordBreak: 'break-word' }}> <a href="javascript:void(0);" onClick={() => this.editParam(record)} >{paramId}</a> 
                                {/* <Button style={{width:160, }} size="small"onClick={() => this.editParam(record)} > 
                                    <div style={{wordBreak:'break-word', wordWrap:'break-word', textOverflow:'ellipsis'}} >{paramId}</div> </Button> */}
                                <Button icon={<CopyOutlined />} type="link" size='small' 
                                    onClick={() => {
                                        if (copy(paramId)) {
                                            message.success('复制成功');
                                        } else {
                                            message.error('复制失败');
                                        }
                                    }} /> 
                            </div>
                            }
                        />
                        <Table.Column
                            title="追踪参数描述(中文名)"
                            dataIndex="remark"
                            key="remark"
                            width={200}
                            ellipsis
                        />
                        <Table.Column
                            title="一级渠道"
                            dataIndex="channelLv1Name"
                            key="channelLv1Name"
                            width={200}
                            ellipsis
                            filters={
                                this.state.channelLevels.filter(cl => cl.level === 1).map(cl => { return { text: cl.name, value: cl.id } })
                            }
                            onFilter={(value, rd) => {
                                if (isEmpty(rd.channelLv1)) {
                                    return false;
                                }
                                return rd.channelLv1 === value;
                            }}
                        />
                        <Table.Column
                            title="二级渠道"
                            dataIndex="channelLv2Name"
                            key="channelLv2Name"
                            width={200}
                            ellipsis
                            filters={this.state.channelLevels.filter(cl => cl.level === 2).map(cl => { return { text: cl.name, value: cl.id } })}
                            onFilter={(value, rd) => {
                                if (isEmpty(rd.channelLv2)) {
                                    return false;
                                }
                                return rd.channelLv2 === value
                            }}
                        />
                        <Table.Column
                            title="渠道名称"
                            dataIndex="channelName"
                            key="channelName"
                            width={200}
                            ellipsis
                            filters={this.state.channels && this.state.channels.map(ci => { return { text: ci.channelName, value: ci.channelName } })}
                            onFilter={(value, rd) => {
                                if (isEmpty(rd.channelName)) {
                                    return false;
                                }
                                return rd.channelName.indexOf(value) >= 0;
                            }}
                        />
                        <Table.Column
                            title="Key"
                            dataIndex="paramKey"
                            key="paramKey"
                            width={100}
                            ellipsis
                            filters={['trace', 'buy_from', 'ADTAG', 'channel', 'utm_source'].map(t => { return { text: t, value: t } })}
                            onFilter={(value, rd) => {
                                if (isEmpty(rd.paramKey)) {
                                    return false;
                                }
                                return rd.paramKey.indexOf(value) >= 0;
                            }}
                        />
                        <Table.Column
                            title="创建人"
                            dataIndex="creator"
                            key="creator"
                            width={100}
                            ellipsis
                            filters={this.state.paramCreators.map(t => { return { text: t, value: t } })}
                            onFilter={(value, rd) => {
                                if (isEmpty(rd.creator)) {
                                    return false;
                                }
                                return rd.creator.indexOf(value) >= 0;
                            }}                            
                        />
                        <Table.Column
                            title="创建时间"
                            dataIndex="createdAt"
                            key="createdAt"
                            width={200}
                            ellipsis
                            render={(time) => moment(time).format('YYYY-MM-DD HH:mm:ss')}
                        />
                        <Table.Column
                            title="修改人"
                            dataIndex="updater"
                            key="updater"
                            width={100}
                            ellipsis
                        />
                        <Table.Column
                            title="修改时间"
                            dataIndex="updatedAt"
                            key="updatedAt"
                            width={200}
                            ellipsis
                            render={(time) => moment(time).format('YYYY-MM-DD HH:mm:ss')}
                        />
                        <Table.Column
                            title="当前状态"
                            dataIndex="status"
                            key="status"
                            width={100}
                            ellipsis
                            filters={[{ text: "使用中", value: 1 }, { text: "已停用", value: 0 }]}
                            onFilter={(value, rd) => {
                                if (isEmpty(rd.status)) {
                                    return false;
                                }
                                return rd.status === value;
                            }}
                            render={(status, record) => 
                                <Switch checkedChildren="使用中" unCheckedChildren="已停用" checked={status} 
                                    onChange={(c) => this.switchParamStatus(record, c ? 1:0)}/>}
                        />
                        <Table.Column
                            title="操作"
                            key="operator"
                            width={180}
                            fixed="right"
                            render={(_, record) => <>
                                <Button
                                    type="link"
                                    size='small'
                                    onClick={() => this.editParam(record)}
                                >编辑</Button>
                                <Popconfirm
                                    title="是否删除指定的参数？"
                                    onConfirm={() => this.deleteParam(record.id)}
                                    onCancel={() => { }}
                                    okText="删除"
                                    okButtonProps={{ danger: true }}
                                    cancelText="取消"
                                >
                                    <Button size='small' type="link" danger >删除</Button>
                                </Popconfirm>
                                <Button
                                    type="link"
                                    size='small'
                                    onClick={() => this.generateLink(record)}
                                >生成链接</Button>
                            </>}
                        />
                    </Table>
                </Col>
            </Row>
            {this.state.showingChannelModal && <TraceChannel
                visible={this.state.showingChannelModal}
                teams={this.props.teams}
                onCancel={() => this.setState({ showingChannelModal: false })}
            />}
            {this.state.showingEditParamModal && <TraceParamEdit
                visible={this.state.showingEditParamModal}
                title={this.state.isCreateParam ? '新增追踪参数' : '编辑追踪参数'}
                teams={this.props.teams}
                isCreate={this.state.isCreateParam}
                editingParam={this.state.editingParam}
                onOk={() => { 
                    this.setState({ showingEditParamModal: false, isCreateParam: false, editingParam: null })
                    this._refreshParams({})
                }}
                onCancel={() => this.setState({ showingEditParamModal: false, isCreateParam: false, editingParam: null }) }
            />}
            {this.state.showingEditLinkModal && <EditLinkModal
                visible={this.state.showingEditLinkModal}
                teams={this.props.teams}
                generatingParam={this.state.generatingLinkParam}
                onOk={() => this.setState({ showingEditLinkModal: false, generatingLinkParam: null })}
                onCancel={() => this.setState({ showingEditLinkModal: false, generatingLinkParam: null })}
            />}
            {this.state.showingImportModal && <ParamImportModal 
                visible={this.state.showingImportModal}
                onOk={() => {
                    this.setState({ showingImportModal: false })
                    this._refreshParams({})
                }}
                onCancel={() => this.setState({ showingImportModal: false })}
            />}
        </>
    }
}

class LinkListView extends React.Component {

    constructor() {
        super()
        this.state={
            keyword: '',
            pageIndex: 0,
            pageSize: 10,
            filters: {
                team: null,
                linkType: null,
                applier: null,
                status: null
            },
            items: [],
            showingEditLinkModal: false,
            appliers: []
        }
    }

    async componentDidMount() {
        this._refreshLinks({ pageIndex: 1})
        this.fetchLinkAppliers()
    }

    async _refreshLinks(params) {
        const keys = ['pageIndex', 'pageSize', 'keyword', 'filters'];
        const queries = [];
        for (let key of keys) {
            if (params[key] === undefined) {
                params[key] = this.state[key];
            }

            if (key === 'filters') {
                queries.push(`${key}=${encodeURI(JSON.stringify(params[key]))}`);
            } else if (params[key] !== undefined) {
                queries.push(`${key}=${encodeURI(params[key])}`);
            }
        }
        this.setState({ ...params });
        const rv = await UIFetchService.get(`/api/v1/trace/links?${queries.join('&')}`);
        if (rv) {
            this.setState({ total: rv.total, items: rv.items });
        }            
    }
    
    async fetchLinkAppliers() {
        UIFetchService.get('/api/v1/trace/links/appliers')
            .then((appliers) => this.setState({ appliers }))
    }

    async switchLinkStatus(link, status) {
        UIFetchService.method('PATCH', `/api/v1/trace/links/${link.id}/switchStatus?status=${status}`)
            .then((result) => {
                if (result != null) {
                    message.success("修改链接状态成功")
                    this.setState(({ items }) => {
                        link.status = status
                        return { items };
                    })
                }
            })     
    }

    async deleteLink(id) {
        UIFetchService.delete(`/api/v1/trace/links/${id}`)
            .then((result) => {
                if (result != null) {
                    message.success("删除链接成功")
                    this._refreshLinks({})
                }
            })
    }

    linkTypeName(linkType) {
        switch (linkType) {
            case 1:
                return '长链接'
            case 2:
                return '短连接'
            case 3:
                return '二维码'
            default:
                return ''
        }
    }

    render() {
        return <>
            <Row style={{marginTop: 25}}>
                <Col flex="10px"></Col>
                <Col>
                    <Input.Search
                        value={this.state.keyword}
                        onChange={async ({ target: { value } }) => await this._refreshLinks({ keyword: value, pageIndex: 1 })}
                        style={{ width: 350 }}
                        placeholder="输入链接描述/追踪参数标识/追踪参数描述"
                    />
                </Col>
                <Col flex="auto"></Col>
                <Col style={{ padding: '0 10px 0 0' }}>
                    <Button
                        size="small"
                        type="primary"
                        onClick={() => this.setState({ showingEditLinkModal: true })}
                    //disabled={isEmpty(this.state.projectName) || isEmpty(this.state.appName)}
                    >新增链接</Button>
                </Col>
            </Row>
            <div style={{ height: 12 }} />
            <Row>
                <Col flex="100%" style={{ padding: '10px' }}>
                    <Table
                        dataSource={this.state.items}
                        bordered
                        size="small"
                        pagination={{
                            total: this.state.total,
                            current: this.state.pageIndex,
                            pageSize: this.state.pageSize,
                        }}
                        rowKey="id"
                        style={{
                            width: '100%',
                        }}
                        scroll={{ y: this.state.tableHeight, x: 1200 }}
                        onChange={(pagination, filters, sorter, { action }) => {
                            this._refreshLinks({
                                pageIndex: pagination.current,
                                pageSize: pagination.pageSize,
                                filters
                            });
                        }}
                    >
                        <Table.Column
                            title="ID"
                            dataIndex="id"
                            key="id"
                            width={80}
                            fixed="left"
                            render={id => <Tag>{id}</Tag>}
                            />
                        <Table.Column
                            title="链接/二维码"
                            dataIndex="linkUrl"
                            key="linkUrl"
                            width={300}
                            fixed="left"
                            render={(linkUrl, record) => record.linkType === 3 ? 
                                <div><Image
                                    src={`/api/v1/trace/links/qrCode?linkUrl=${encodeURI(linkUrl)}`}
                                    height={50}
                                /> <Button icon={<CopyOutlined />} type="link" size='small' 
                                onClick={async _ => {
                                    try {
                                        const img = await fetch(`/api/v1/trace/links/qrCode?linkUrl=${encodeURI(linkUrl)}`)
                                        const blob = new Blob([await img.blob()], { type: 'image/png' });
                                        await navigator.clipboard.write([
                                            new window.ClipboardItem({
                                            'image/png': blob
                                            })
                                        ]);
                                        message.success("复制成功")
                                    } catch (_) {
                                        message.error('复制失败');
                                    }
                                    
                                }} />
                                </div>: 
                                <div style={{ wordWrap: 'break-word', wordBreak: 'break-word' }}> <span>{linkUrl}</span> <Button icon={<CopyOutlined />} type="link" size='small' 
                                onClick={() => {
                                    if (copy(linkUrl)) {
                                        message.success('复制成功');
                                    } else {
                                        message.error('复制失败');
                                    }
                                }} /> </div>}
                        />
                        <Table.Column
                            title="链接描述"
                            dataIndex="linkRemark"
                            key="linkRemark"
                            width={200}
                            ellipsis
                        />
                        <Table.Column
                            title="链接类型"
                            dataIndex="linkType"
                            key="linkType"
                            width={100}
                            render={linkType => <span> {this.linkTypeName(linkType)} </span>}
                            filters={[{ text: '长链接', value: 1 }, {text: '短链接', value: 2}, {text: '二维码', value: 3}]}
                            onFilter={(value, rd) => {
                                if (isEmpty(rd.linkType)) {
                                    return false;
                                }
                                return rd.linkType === value;
                            }}
                        />
                        <Table.Column
                            title="追踪参数标识"
                            dataIndex="paramId"
                            key="paramId"
                            width={200}
                            ellipsis
                        />
                        <Table.Column
                            title="追踪参数描述(中文名)"
                            dataIndex="paramRemark"
                            key="paramRemark"
                            width={200}
                            ellipsis
                        />
                        <Table.Column
                            title="所属团队"
                            dataIndex="team"
                            key="team"
                            width={200}
                            ellipsis
                            filters={this.props.teams.map(t => { return { text: t, value: t } })}
                            onFilter={(value, rd) => {
                                if (isEmpty(rd.team)) {
                                    return false;
                                }
                                return rd.team.indexOf(value) >= 0;
                            }}
                        />
                        <Table.Column
                            title="申请人"
                            dataIndex="applier"
                            key="applier"
                            width={100}
                            ellipsis
                            filters={this.state.appliers.map(t => { return { text: t, value: t } })}         
                        />
                        <Table.Column
                            title="申请时间"
                            dataIndex="createdAt"
                            key="createdAt"
                            width={200}
                            ellipsis
                            render={(time) => moment(time).format('YYYY-MM-DD HH:MM:SS')}
                        />
                        <Table.Column
                            title="当前状态"
                            dataIndex="status"
                            key="status"
                            width={100}
                            ellipsis
                            filters={[{ text: "使用中", value: 1 }, { text: "已停用", value: 0 }]}
                            onFilter={(value, rd) => {
                                if (isEmpty(rd.status)) {
                                    return false;
                                }
                                return rd.status === value;
                            }}
                            render={(status, record) => 
                                <Switch checkedChildren="使用中" unCheckedChildren="已停用" checked={status} 
                                    onChange={(c) => this.switchLinkStatus(record, c ? 1:0)}/>}
                        />
                        <Table.Column
                            title="操作"
                            key="operator"
                            width={80}
                            fixed="right"
                            render={(_, record) => <>
                                <Popconfirm
                                    title="是否删除指定的链接？"
                                    onConfirm={() => this.deleteLink(record.id)}
                                    onCancel={() => { }}
                                    okText="删除"
                                    okButtonProps={{ danger: true }}
                                    cancelText="取消"
                                >
                                    <Button size='small' type="link" danger >删除</Button>
                                </Popconfirm>
                            </>}
                        />
                    </Table>
                </Col>
            </Row>
            {this.state.showingEditLinkModal && <EditLinkModal
                visible={this.state.showingEditLinkModal}
                teams={this.props.teams}
                onOk={() => {
                    this.setState({ showingEditLinkModal: false })
                    this._refreshLinks({})
                }}
                onCancel={() => this.setState({ showingEditLinkModal: false })}
            />}
        </>
    }
}

class EditLinkModal extends React.Component {

    constructor() {
        super()
        this.state = {
            basicInfos:[],
            team: null,
            channel: null,
            channelId: null,
            paramKey: '',
            paramId: '',
            originalUrl: '',
            remark: '',
            longUrl: '',
            shortUrl: '',
            qrCode: '',
            paramOptions: {}
        }
    }

    async componentDidMount() {
        if (this.props.generatingParam != null) {
            const team = this.props.generatingParam.team
            const channel = this.props.generatingParam.channel
            const channelId = this.props.generatingParam.channelId
            await this.channelSelected(channelId)
            const paramId = this.props.generatingParam.paramId
            const paramKey = this.props.generatingParam.paramKey


            this.setState({
                team,
                channel,
                channelId,
                paramId,
                paramKey
            })
        }
    }

    async generateLongUrl() {
        const longUrl = this._getLongUrl()
        if (longUrl == null) {
            return
        }

        this.setState({ longUrl })
        message.success("生成长链接成功")
    }

    async channelSelected(channelId) {
        const params = await UIFetchService.get(`/api/v1/trace/channelId/${channelId}/params`)

        if (params != null) {
            let paramOptions = {}
            for (const param of params) {
                paramOptions[param.paramId] = param.paramKey
            }

            this.setState({ channelId, paramOptions })
        }
    }

    async generateShortUrl() {
        const longUrl = this._getLongUrl()
        if (longUrl == null) {
            return
        }

        UIFetchService.get(`/api/v1/trace/links/shortLink?linkUrl=${encodeURI(longUrl)}`)
            .then((result) => {
                if (result == null) {
                    message.error("生成短链接失败")
                    return
                }

                this.setState({ shortUrl: result['shortUrl'] })
                message.success("生成短链接成功")
            })
    }

    async generateQrCode() {
        const longUrl = this._getLongUrl()
        if (longUrl == null) {
            return
        }

        this.setState({ qrCode: longUrl })
        message.success("生成二维码成功")
    }

    _getLongUrl() {
        if (isEmpty(this.state.originalUrl)) {
            message.error("请输入原始链接")
            return null
        }

        if (isEmpty(this.nameValuePairStr)) {
            message.error("请选择追踪参数")
            return null
        }

        var url = new URL(this.state.originalUrl);
        url.searchParams.set(this.state.paramKey, this.state.paramId);
        
        return url.toString()
    }

    get nameValuePairStr() {
        if (isEmpty(this.state.paramKey) || isEmpty(this.state.paramId)) {
            return ''
        }

        return this.state.paramKey + '=' + this.state.paramId
    }

    async saveUrls() {
        if (isEmpty(this.state.paramId)) {
            message.error("请选择追踪参数")
            return
        }

        if (isEmpty(this.state.originalUrl)) {
            message.error("请输入原始链接")
            return
        }

        if (isEmpty(this.state.remark)) {
            message.error("请输入链接描述")
            return
        }

        let links = []
        if (isNotEmpty(this.state.longUrl)) {
            links.push({
                paramId: this.state.paramId,
                originalUrl: this.state.originalUrl,
                remark: this.state.remark,
                linkUrl: this.state.longUrl,
                linkType: 1,
                status: 1
            })
        }

        if (isNotEmpty(this.state.shortUrl)) {
            links.push({
                paramId: this.state.paramId,
                originalUrl: this.state.originalUrl,
                remark: this.state.remark,
                linkUrl: this.state.shortUrl,
                linkType: 2,
                status: 1
            })
        }
        
        if (isNotEmpty(this.state.qrCode)) {
            links.push({
                paramId: this.state.paramId,
                originalUrl: this.state.originalUrl,
                remark: this.state.remark,
                linkUrl: this.state.qrCode,
                linkType: 3,
                status: 1
            })
        }

        if (links.length === 0) {
            message.error("请至少生成一个链接/二维码")
            return
        }
        const result = await UIFetchService.post(`/api/v1/trace/links`, links)
        if (result == null) {
            message.error("保存链接失败")
            return 
        }

        message.success("保存链接成功")
        this.props.onOk()
    }

    async cancel() {
        this.props.onCancel()
    }

    render() {
        return <Modal
            title="生成链接"
            visible={this.props.visible}
            onOk={this.saveUrls.bind(this)}
            onCancel={this.cancel.bind(this)}
            maskClosable={false}
            width={880}
            okText="保存"
        >
            <Row>
                <Col flex="100%">
                    <div style={{paddingTop: 15, paddingBottom: 10, marginBottom: 15, borderRadius: 6, backgroundColor: "rgba(245, 245, 245, 0.61)" }}>
                    <Row justify="center" style={{ marginBottom: 15 }}>
                        <Col flex="120px">
                            <span style={{color: '#ff4d4f'}}>*&nbsp;</span><span>选择追踪参数：</span>
                        </Col>
                        <Col flex="200px">
                            <Select
                                placeholder="所属团队"
                                value={this.state.team}
                                style={{ width: '100%' }}
                                onChange={async value => {
                                    this.setState({ team: value });
                                }}
                                disabled={this.props.generatingParam != null}
                            >
                                { this.props.teams.map( team => <Select.Option key={team} value={team}> {team} </Select.Option>) }
                            </Select>
                        </Col>
                        <Col flex="200px">
                            <Select
                                value={this.state.channelId}
                                style={{ width: '100%' }}
                                onChange={(c) => this.channelSelected(c)}
                                placeholder="所属渠道"
                                disabled={this.props.generatingParam != null}
                            >
                                { this.state.basicInfos
                                    .filter(bi => bi.team === this.state.team)
                                    .map(bi => <Select.Option key={bi.channelId} value={bi.channelId}> {bi.channel} </Select.Option>) }
                            </Select>
                        </Col>
                        <Col flex="230px">
                            <Select style={{color: '#000000', width: '100%'}}
                                placeholder="追踪参数"
                                value={ this.state.paramId }
                                onChange={async value => {
                                    this.setState({ paramId: value, paramKey: this.state.paramOptions[value] });
                                }}
                                disabled={this.props.generatingParam != null}
                            >
                                { Object.keys(this.state.paramOptions).map(paramId => 
                                    <Select.Option key={paramId} value={paramId}> {`${this.state.paramOptions[paramId]}=${paramId}`} </Select.Option>) 
                                }
                            </Select>                            
                        </Col>
                        <Col flex="25px"></Col>
                    </Row>
                    <Row justify="center" style={{ marginBottom: 15 }}>
                        <Col flex="120px">
                            <span style={{color: '#ff4d4f'}}>*&nbsp;</span><span>输入原始链接：</span>
                        </Col>
                        <Col flex="630px">
                            <Input value={this.state.originalUrl} onChange={(e) => this.setState({ originalUrl: e.target.value })} />
                        </Col>
                        <Col flex="25px"></Col>
                    </Row>
                    <Row justify="center">
                        <Col flex="120px">
                            <span style={{color: '#ff4d4f'}}>*&nbsp;</span><span>输入链接描述：</span>
                        </Col>
                        <Col flex="630px">
                            <Input value={this.state.remark} onChange={(e) => this.setState({ remark: e.target.value })} />
                        </Col>
                        <Col flex="25px"></Col>
                    </Row>
                    </div>
                    <Row justify="center" style={{ marginBottom: 15 }}>
                        <Col flex="120px">
                            <Button
                                type="primary"
                                onClick={() => this.generateLongUrl()}
                            > 生成长链接
                            </Button>                             
                        </Col>
                        <Col flex="630px">
                            <Input style={{backgroundColor: '#ffffff'}} value={this.state.longUrl} disabled />
         
                        </Col>
                        <Col flex="25px">
                            <Button icon={<CopyOutlined />} type="link" size='small' 
                                onClick={() => {
                                    if (copy(this.state.longUrl)) {
                                        message.success('复制成功');
                                    } else {
                                        message.error('复制失败');
                                    }
                                }} />
                        </Col>
                    </Row>
                    <Row justify="center" style={{ marginBottom: 15 }}>
                        <Col flex="120px">
                            <Button
                                type="primary"
                                onClick={() => this.generateShortUrl()}
                            > 生成短链接
                            </Button>                             
                        </Col>
                        <Col flex="630px">
                            <Input style={{backgroundColor: '#ffffff'}} value={this.state.shortUrl} disabled />
                        </Col>
                        <Col flex="25px">
                        <Button icon={<CopyOutlined />} type="link" size='small' 
                                onClick={() => {
                                    if (copy(this.state.shortUrl)) {
                                        message.success('复制成功');
                                    } else {
                                        message.error('复制失败');
                                    }
                                }} />
                        </Col>
                    </Row>
                    <Row justify="center" style={{ marginBottom: 15 }}>
                        <Col flex="120px">
                            <Button
                                type="primary"
                                onClick={() => this.generateQrCode()}
                            > 生成二维码
                            </Button>                             
                        </Col>
                        <Col flex="630px">
                            {isEmpty(this.state.qrCode) ? null :
                            <>
                            <Image
                                    src={`/api/v1/trace/links/qrCode?linkUrl=${encodeURI(this.state.qrCode)}`}
                                    height={200}
                                />
                            <Button icon={<CopyOutlined />} type="link" size='small' 
                            onClick={async _ => {
                                try {
                                    const img = await fetch(`/api/v1/trace/links/qrCode?linkUrl=${encodeURI(this.state.qrCode)}`)
                                    const blob = new Blob([await img.blob()], { type: 'image/png' });
                                    await navigator.clipboard.write([
                                        new window.ClipboardItem({
                                        'image/png': blob
                                        })
                                    ]);
                                    message.success("复制成功")
                                } catch (_) {
                                    message.error('复制失败');
                                }
                                
                            }} />
                            </>
                            }
                        </Col>
                        <Col flex="25px"></Col>
                    </Row>
                </Col>
            </Row>
            <Row justify="center" style={{marginTop: 30}}>
                <Col flex="100%">
                    <p style={{color: '#969faf'}}>使用说明：<br/>
                    1. 生成该追踪参数对应的渠道链接<br/>
                    2. 在不同场景下使用长链接/短连接/二维码进行售卖或推广，研发可在埋点中传递此参数以追踪数据来源。</p>
                </Col>
            </Row>
        </Modal>
    }
}

class ParamImportModal extends React.Component {
    constructor() {
        super();
        this.state = {
            data: [
                ['追踪参数标识', '追踪参数描述', '一级渠道', '二级渠道', '渠道名称', 'key', '标签', '当前状态', '创建人', '所属团队'],
                [null, null, null, null, null, null, null, null, null, null]
            ]
        }
    }

    render() {
        return <Modal
            title="导入数据"
            {...this.props}
            onOk={this.commitData.bind(this)}
            okText='导入'
            width={800}
            maskClosable={false}
        >
            <Row>
                <Col flex="100%">
                    <HotTable
                        height={400}
                        rowHeaders
                        colHeaders
                        data={this.state.data}
                        language="zh-CN"
                        manualColumnResize
                        manualRowResize
                        cells={row => {
                            if (row === 0) {
                                return { renderer: this.titleRenderer }
                            } else {
                                return {};
                            }
                        }}
                        fixedRowsTop={1}
                        licenseKey="non-commercial-and-evaluation"
                    >
                    </HotTable>
                </Col>
            </Row>
            <Row>
                <span style={{ color: 'gray' }}>将要导入的数据粘贴在上表空白处。</span>
            </Row>
        </Modal>
    }

    async commitData() {
        const rv = await UIFetchService.post('/api/v1/trace/params/import', this.state.data);
        if (rv && rv.rows !== undefined) {
            message.success(`成功导入: ${rv.rows} 条记录`);
            this.props.onOk();
        } else {
            message.error('导入失败。');
        }
    }

    titleRenderer = (instance, td, row, col, prop, value, cellProperties) => {
        cellProperties.readOnly = true;
        Handsontable.renderers.TextRenderer.apply(Handsontable.renderers.TextRenderer,
            [instance, td, row, col, prop, value, cellProperties]);
        
        if (col === 6) {
            td.style.fontWeight = 'bold';
            td.style.color = 'black';
            td.style.background = '#F0F0F0';
        } else {
            td.style.fontWeight = 'bold';
            td.style.color = 'red';
            td.style.background = '#F0F0F0';
        }
    }
}


export default TraceParamsView;